import { createContext, Dispatch, SetStateAction } from 'react';
import { CalculatorOutputFields } from '../utils/CalculatorOutputValue';
import { CalculatorInputFieldsType } from '../utils/CalculatorInputValue';

export const CalculatorFieldsContext = createContext<[CalculatorInputFieldsType, Dispatch<SetStateAction<CalculatorInputFieldsType>>] | null>(null);

export const CalculatorOutputFieldsContext = createContext<CalculatorOutputFields | null>(null);
